import { render, staticRenderFns } from "./ComponentWrapper.vue?vue&type=template&id=6e6bb50f"
import script from "./ComponentWrapper.vue?vue&type=script&lang=js"
export * from "./ComponentWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports